export default {"src":"/_next/static/media/bg_green_m.1bb12d72.svg","height":725,"width":639,"blurWidth":0,"blurHeight":0};